<template>
  <div id="app">
    <template
      v-if="
        route.path.startsWith('/login') || route.path.startsWith('/register')
      "
    >
      <router-view />
    </template>
    <template v-else>
      <LayOut></LayOut>
    </template>
  </div>
</template>
<script setup>
import { useRoute } from "vue-router";
import { defineAsyncComponent } from "vue";
const LayOut = defineAsyncComponent(() => import("./layout/index.vue"));
const route = useRoute();
</script>
<style>
html,
body {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
#app {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}
</style>
